import React from 'react';
import { connect } from 'react-redux'
import { branch, compose, renderComponent } from 'recompose'
import { opticianActions, opticianSelectors } from './redux'
import { sessionSelectors } from '../session/redux'
import lifeCycle from './OpticianListLifecycle'
import OpticianList from "./OpticianList";
import Loading from '../../components/Loading'
import { careUnitActions, careUnitSelectors } from "../careUnit/redux";

const mapStateToProps = (state) => ({
    opticians: opticianSelectors.opticianList(state),
    createDialogOpen: opticianSelectors.createDialogOpen(state),
    updateDialogOpen: opticianSelectors.updateDialogOpen(state),
    opticianForm: opticianSelectors.opticianForm(state),
    careUnits: careUnitSelectors.careUnitList(state),
    careUnitOrganizationIds: null,
    saveOpticianError: opticianSelectors.saveOpticianError(state),
    loggedInUser: sessionSelectors.loggedInUser(state),
    loggedInUserRole: sessionSelectors.role(state),
    errorMessage: opticianSelectors.errorMessage(state),
    isLoading: opticianSelectors.isLoading(state),
    linkDialogOpen: opticianSelectors.linkDialogOpen(state),
    linkableOpticians: opticianSelectors.linkableOpticians(state),
    linkError: opticianSelectors.linkError(state),
});

const mapDispatchToProps = (dispatch) => ({
    listOpticians: () => dispatch(opticianActions.listOpticians()),
    listCareUnits: () => dispatch(careUnitActions.listCareUnits()),
    updateOpticianClicked: (opticianForm) => dispatch(opticianActions.openUpdateDialog(opticianForm)),
    addOpticianClicked: () => dispatch(opticianActions.openCreateDialog()),
    closeDialogClicked: () => dispatch(opticianActions.closeDialogs()),
    createOptician: (opticianForm) => dispatch(opticianActions.createOptician(opticianForm)),
    updateOptician: (opticianForm) => dispatch(opticianActions.updateOptician(opticianForm)),
    deleteOptician: (opticianForm) => dispatch(opticianActions.deleteOptician(opticianForm)),
    openLinkDialog: () => dispatch(opticianActions.openLinkDialog()),
    closeLinkDialog: () => dispatch(opticianActions.closeLinkDialog()),
    linkOptician: (organizationId) => dispatch(opticianActions.linkOptician(organizationId)),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    lifeCycle,
    branch(({ isLoading, opticians, careUnits, errorMessage, createDialogOpen, updateDialogOpen, linkDialogOpen }) =>
            (isLoading || (!errorMessage && (!opticians || !careUnits))) && !createDialogOpen && !updateDialogOpen && !linkDialogOpen,
        renderComponent(() => <Loading title={'Laddar...'} />)
    )
)(OpticianList)